import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

import { EPISODE_STATUSES } from 'app/utils/constants';

const getMyStories = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/my-stories/?${params}`);
};

const getMyCommunities = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/communities/?${params}`);
};
const getMyStory = (storyId) => API.get(`/my-stories/${storyId}/`);

const createMyStory = (data) => API.post('/my-stories/', data);

/**
 * @param {number} storyId
 * @param {object} data - title, coverImage, genres, summary, categoryId
 */
const patchMyStory = (storyId, data) =>
  API.patch(`/my-stories/${storyId}/`, data);

const deleteMyStory = (storyId) => API.delete(`/my-stories/${storyId}/`);

const getMyStoryEpisodes = (
  storyId,
  ordering = 'pubest',
  status = 'all',
  page = 1,
  perPage = 20
) => {
  const params = toParams({ page, perPage, ordering, status });
  return API.get(`/my-stories/${storyId}/episodes/?${params}`);
};

const getMyEpisode = (storyId, episodeId) =>
  API.get(`/my-stories/${storyId}/episodes/${episodeId}/`);

const createMyEpisode = (storyId, rewriteTargetId) =>
  API.post(`/my-stories/${storyId}/episodes/`, {
    title: '무제',
    status: EPISODE_STATUSES.PRIVATE.type,
    ...(rewriteTargetId ? { rewriteTargetId } : {}),
  });

const deleteMyEpisode = (storyId, episodeId) =>
  API.delete(`/my-stories/${storyId}/episodes/${episodeId}/`);

/**
 * @param {number} storyId
 * @param {number} episodeId
 * @param {object} data - title, status, draft
 */
const patchMyEpisode = (storyId, episodeId, data) =>
  API.patch(`/my-stories/${storyId}/episodes/${episodeId}/`, data);

const saveDraft = (storyId, episodeId, draft) =>
  API.patch(`/my-stories/${storyId}/episodes/${episodeId}/draft/`, { draft });

const getMyStoryAds = (storyId, page = 1) =>
  API.get(`/my-stories/${storyId}/ads/?page=${page}`);

const postMyStoryAd = (storyId, episodeId, balloon, voucherId = null) =>
  API.post(`/my-stories/${storyId}/ads/`, {
    episodeId,
    balloon,
    ...(voucherId ? { voucherId } : {}),
  });

const patchMyStoryAd = (storyId, storyAdId, status) =>
  API.patch(`/my-stories/${storyId}/ads/${storyAdId}/`, { status });

const getLatestMyStory = () => API.get('/my-stories/latest/');

const getCategories = () => API.get('/categories/');

const getViewerInfo = (storyId) =>
  API.get(`/my-stories/${storyId}/viewer-info/`);

const getStoryAdEventCheck = (name) =>
  API.get(`/story-ads/event-check/?name=${name}`);

const postEpisodeBooking = (storyId, episodeId, data) =>
  API.post(`/my-stories/${storyId}/episodes/${episodeId}/booking/`, data);

const deleteBooked = (storyId, episodeId) =>
  API.delete(`/my-stories/${storyId}/episodes/${episodeId}/booking/`);

const postEpisodeStatistic = (storyId, episodeId) =>
  API.post(`/my-stories/${storyId}/episodes/${episodeId}/statistic/`);

export default {
  getMyStories,
  getMyCommunities,
  getMyStory,
  createMyStory,
  patchMyStory,
  deleteMyStory,
  getMyStoryEpisodes,
  getMyEpisode,
  createMyEpisode,
  deleteMyEpisode,
  patchMyEpisode,
  saveDraft,
  getMyStoryAds,
  postMyStoryAd,
  patchMyStoryAd,
  getLatestMyStory,
  getCategories,
  getViewerInfo,
  getStoryAdEventCheck,
  postEpisodeBooking,
  deleteBooked,
  postEpisodeStatistic,
};



// WEBPACK FOOTER //
// ./src/app/apis/studio.js